import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../auth";
import { getPublicSiteConfig } from "../../services/platformConfigService";

export default function MaintenanceGate({ children }) {
  const user = useSelector(selectUser);
  const [maintenance, setMaintenance] = useState(false);

  useEffect(() => {
    let active = true;
    getPublicSiteConfig()
      .then((config) => {
        if (active) setMaintenance(config?.maintenanceMode === true);
      })
      .catch(() => {
        if (active) setMaintenance(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const role = String(user?.role || user?.currentMode || "").toLowerCase();
  const isAdmin = role === "superadmin" || role === "admin";
  if (!maintenance || isAdmin) return children;

  return (
    <main className="container py-5" style={{ maxWidth: 640 }}>
      <h1 className="h3">Swarand is temporarily unavailable</h1>
      <p className="text-muted mb-0">
        We are updating the library. Please try again shortly. Signed-in administrators can still open the site.
      </p>
    </main>
  );
}
